import { z } from 'zod'
import { stringSchema } from './common'
import { cartAddOnSchema } from './cart'

const questionsSchema = z.array(z.object({
  id: stringSchema.min(1),
  question: stringSchema.min(1),
  answer_input_type: stringSchema.min(1),
  optional: z.boolean().optional(),
  options: z.array(z.object({
    option: stringSchema.min(1),
    id: stringSchema.min(1),
    requires_text: z.boolean().optional(),
  })).nullish()
}))

export const attributionQuestionSchema = z.object({
  id: stringSchema.min(1),
  question: stringSchema.min(1),
  options: z.array(z.object({
    id: stringSchema.min(1),
    option: stringSchema.min(1),
    requires_text: z.boolean(),
  })).min(1),
})

export type AttributionQuestion = z.infer<typeof attributionQuestionSchema>

export type AttributionAnswer = {
  question_option_id: string | null
  text_response: string | null
}
export const orderSchema = z.object({
  id: stringSchema.min(1),
  order_number: stringSchema.min(1),
  status: stringSchema.min(1),
  payment_status: stringSchema.nullish(),
  total: z.number(),
  currency: stringSchema.nullish(),
  isExpanded: z.boolean(),
  expiresAt: z.number().nullish(),
  paymentExpiresAt: z.number().nullish(),
  discount: z.number(),
  coupon_code: stringSchema.nullish(),
  createdAt: stringSchema.min(1),
  client: z.object({
    email: stringSchema.min(1),
    firstName: stringSchema.min(1),
    lastName: stringSchema.min(1),
  }).nullish(),
  // BOAT-1979: only set for an active policy.
  ticketProtection: z.object({
    amount: z.number(),
    currency: stringSchema.nullish(),
    termsUrl: stringSchema.nullish(),
  }).nullish(),
  items: z.array(
    z.object({
      id: stringSchema.min(1),
      lineId: stringSchema.nullish(),
      covered: z.boolean().default(false),
      type: stringSchema.nullish(),
      quantity: z.number(),
      image: stringSchema.nullish(),
      price: z.number(),
      packageId: stringSchema.nullish(),
      title: stringSchema.min(1),
      details: stringSchema.nullish(),
      date: z.string().nullish(),
      isActive: z.boolean(),
      discount: z.number(),
      favourited: z.string().nullish(),
      path: z.string().nullish(),
      venue: z.object({
        name: stringSchema.nullish(),
        address: stringSchema.nullish(),
      }).nullish(),
    }),
  ),
  addOns: z.array(cartAddOnSchema).default([]),
  questions: questionsSchema.nullish(),
})
